import React, { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../components/layouts/main-layout";
import {
  invoiceDeleteAction,
  invoiceTableAction,
  invoiceViewAction,
} from "../../redux/actions/invoices-action";
import InvoiceFilter from "../../components/tables/table-filter/invoice-filter";
import DynamicTransactionTable from "../../components/tables/dynamic-transaction-table";
import BadgesComponent from "../../components/tables/badges-component";
import RupeesIcon from "../../assets/icons/billing-container-icons/rupee-icon";
import TimerIconBg from "../../assets/icons/billing-container-icons/timer-icon";
import ReturnIcon from "../../assets/icons/billing-container-icons/return-icon";
import AvgSaleIcon from "../../assets/icons/billing-container-icons/avg-sales-icon";
import CashIcon from "../../assets/icons/pay-method-icons/cash-icon";
import CardIcon from "../../assets/icons/pay-method-icons/card-icon";
import UpiICon from "../../assets/icons/pay-method-icons/upi-icon";
import TimerIcon from "../../assets/icons/timer-icon";
import TransSummaryComp from "../../components/helper-components/trans-summary-comp";
import AddButton from "../../components/buttons/button";
import { api } from "../../redux/apis/api";
import successToast from "../../components/helper-components/success-toast";
import errorToast from "../../components/helper-components/error-toast";
import { isAdmin } from "../../redux/config";
import {
  getRowSyncState,
  getBulkSyncState,
  setSyncFrozenNow,
  formatDashboardCountdown,
  DASHBOARD_SYNC_FREEZE_DURATION_MS,
} from "../../components/helper-components/sync-freeze";
import useSyncFreezeTick from "../../components/helper-components/use-sync-freeze-tick";

const BillingTable = () => {
  useSyncFreezeTick();
  const [billSummary, setBillSummary] = useState({});
  const [heading, setHeading] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [action, setAction] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [reload, setReload] = useState(false);
  const [syncStates, setSyncStates] = useState({});
  const [syncTodaysLoading, setSyncTodaysLoading] = useState(false);
  const [billingLastSynced, setBillingLastSynced] = useState(null);

  const fetchBillingSyncTimings = useCallback(async () => {
    try {
      const res = await api.get(`/sync-dashboard/timings`);
      const timings = res?.data?.data ?? [];
      const billing = timings.find((t) => t?.type === "billing");
      setBillingLastSynced(billing?.last_synced ?? null);
    } catch (err) {
      // ignore; button falls back to enabled if timings are unavailable
    }
  }, []);

  useEffect(() => {
    fetchBillingSyncTimings();
  }, [fetchBillingSyncTimings]);

  const handleHardSync = async (sotId, e) => {
    e.stopPropagation();
    const item = orders.find((o) => o?.sot_id === sotId);
    const syncState = getRowSyncState({
      moduleKey: "billing",
      id: sotId,
      dataSynced: item?.data_synced,
      lastSynced: item?.last_synced,
    });
    if (syncState.disabled) return;
    setSyncStates((prev) => ({ ...prev, [sotId]: "syncing" }));
    try {
      const res = await api.post(`/order/hard_sync`, {}, { params: { sot_id: sotId } });
      if (res?.data?.status === false) {
        errorToast(res?.data?.message ?? "Sync failed");
      } else {
        setSyncFrozenNow(`billing_${sotId}`);
        successToast(res?.data?.message ?? "Sync successful");
      }
    } catch (err) {
      errorToast(err?.response?.data?.message ?? "Sync failed");
    }
    setSyncStates((prev) => ({ ...prev, [sotId]: "synced" }));
  };

  const handleSyncTodaysBills = async () => {
    const todaysBulkState = getBulkSyncState({
      moduleKey: "billing_todays_bulk",
      lastSynced: billingLastSynced,
    });
    if (todaysBulkState.disabled) return;
    const today = new Date().toLocaleDateString("sv-SE");
    setSyncTodaysLoading(true);
    try {
      const res = await api.post(
        `/order/hard_sync`,
        {},
        { params: { from_date: today, to_date: today } }
      );
      if (res?.data?.status === false) {
        errorToast(res?.data?.message ?? "Failed to sync today's bills");
      } else {
        setSyncFrozenNow("billing_todays_bulk", DASHBOARD_SYNC_FREEZE_DURATION_MS);
        successToast(res?.data?.message ?? "Today's bills synced successfully");
        fetchBillingSyncTimings();
      }
    } catch (err) {
      errorToast(err?.response?.data?.message ?? "Failed to sync today's bills");
    } finally {
      setSyncTodaysLoading(false);
    }
  };

  useEffect(() => {
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const billingData = parsed.find((obj) => obj?.Billing_list);
      // if (billingData?.Billing_list) {
      //   setHeading(billingData.Billing_list);
      // }
      if (billingData?.Billing_list) {
        setHeading(
          billingData.Billing_list.map((heading) =>
            heading?.value === "payment_modes"
              ? { ...heading, display: false }
              : heading
          )
        );
      }
    }
  }, [loading]);

  console.log(loading, "loading");

  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    order_status: "",
    payment_status: "",
  });
  useEffect(() => {
    dispatch(
      invoiceTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.orderList ?? []);
    setDataCount(data?.data?.totalCount);
    setBillSummary(data?.data?.getorderStats?.[0]);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };
  const navigate = useNavigate();
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const initialFilter = {
    sort_by: "",
    sort_order: "",
    selectColumn: "sot_invoice_number",
    from: "",
    to: "",
    inputValue: "",
    order_status: "",
    payment_status: "",
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        action &&
        currentIndex != null &&
        !event.target.closest(".relative")
      ) {
        setAction(false);
        setCurrentIndex(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [action, currentIndex]);

  const tableBodyData = orders?.map((item) => {
    const syncState = getRowSyncState({
      moduleKey: "billing",
      id: item?.sot_id,
      dataSynced: item?.data_synced,
      lastSynced: item?.last_synced,
    });
    return {
      id: item?.sot_id,
      sot_invoice_number:
        <span>{item?.sot_invoice_number ?? "--"}</span> ?? "--",

      sot_custom_invoice_number: item?.sot_custom_invoice_number ?? "--",

      cmr_phone_number: item?.cmr_phone_number,

      cmr_first_name: item?.cmr_first_name ?? "",
      payment_modes:
        item?.payment_modes?.length > 0 ? (
          <div className="flex gap-1 flex-wrap">
            {item.payment_modes.map((pay, index) => (
              <span key={index}>
                {pay?.payment_mode_name ?? "--"}
                {index !== item.payment_modes.length - 1 ? "," : ""}
              </span>
            ))}
          </div>
        ) : (
          <span>--</span>
        ),
      prescription: item?.prescription ? "Y" : "N" ?? "N",
      doctor_name: item?.doctor_name ? "Dr" + " " + item?.doctor_name : "--",

      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
      order_status: (
        <BadgesComponent
          status={item?.is_draft_order ? "draft" : "completed"}
        />
      ),
      // (
      //   <span
      //     className={`${
      //       item?.is_draft_order
      //         ? "border-344054 border text-344054"
      //         : "text-027A48 border-027A48 border "
      //     } px-2 py-1 rounded-full text-xs whitespace-nowrap`}
      //   >
      //     {item?.is_draft_order ? "Saved as Draft" : "Completed"}
      //   </span>
      // ),
      sot_payment_status: <BadgesComponent status={item?.sot_payment_status} />,

      // (
      //   <span
      //     style={{
      //       width: "fit-content",
      //       backgroundColor:
      //         item?.sot_payment_status === "paid"
      //           ? "var(--success-color-opacity)" // Fully opaque success color
      //           : "var(--danger-color-opacity)", // F51D00 with approximately 15% opacity
      //     }}
      //     className={`text-xs ${
      //       item?.sot_payment_status === "paid" ? "text-027A48" : "text-F51D00"
      //     } fw_500 flex items-center gap-2 px-3 py-1 rounded-full`}
      //   >
      //     <StatusIcons status={item?.sot_payment_status} />
      //     {formatString(item?.sot_payment_status)}
      //   </span>
      // ),

      sot_return_status: <BadgesComponent status={item?.sot_return_status} />,
      //  (
      //   <span
      //     className={`${
      //       item?.sot_return_status === "open"
      //         ? "border-344054 border text-344054"
      //         : item?.sot_return_status === "closed"
      //         ? "text-027A48 border-027A48 border "
      //         : "border-f51d00 border text-F51D00 "
      //     } px-2 py-1 rounded-full whitespace-nowrap text-xs `}
      //   >
      //     {item?.sot_return_status === "open"
      //       ? "Open"
      //       : item?.sot_return_status === "closed"
      //       ? "Closed"
      //       : "Cancelled"}
      //   </span>
      // ),
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",

      sot_total_amount: "₹ " + item?.sot_total_amount,
      invoice_profit_percentage:
        item?.invoice_profit_percentage != null
          ? parseFloat(item?.invoice_profit_percentage).toFixed(2) + " %"
          : "--",
      is_draft_order: item?.is_draft_order,
      itemData: item?.itemData?.length > 0 ? item?.itemData : [],
      cmr_id: item?.cmr_id ?? "--",
      return_status: item?.sot_return_status ?? "",
      sot_order_status: item?.is_draft_order ? "draft" : "open",
      sot_custom_invoice_number: item?.sot_custom_invoice_number ?? "--",
      store_code: item?.store_code ?? "--",
      store_name: item?.store_name ?? "--",
      store_type: item?.store_type ?? "--",
      firm_name: item?.firm_name ?? "--",
      cmr_code: item?.cmr_code ?? "--",
      sync_action: (
        <button
          disabled={syncStates[item?.sot_id] === "syncing" || syncState.disabled}
          onClick={(e) => handleHardSync(item?.sot_id, e)}
          title={syncState.synced ? `Last synced: ${syncState.label}` : ""}
          className="border-radius hover:bg-[var(--primary-button-hover-color)] flex justify-center h-[32px] px-[12px] items-center whitespace-nowrap transition duration-300 ease-in-out text-[length:--primary-button-font-size] font-[var(--primary-button-font-weight)] bg-[var(--primary-button-bg-color)] text-[var(--primary-button-fg-color)] disabled:opacity-50 disabled:cursor-not-allowed min-w-[64px]"
        >
          {syncStates[item?.sot_id] === "syncing"
            ? "Initiating..."
            : syncState.label}
        </button>
      ),
    };
  });

  const filterby = showFilter ? (
    <InvoiceFilter
      setCurrentPage={setCurrentPage}
      filterData={filterData}
      setFilterData={setFilterData}
    />
  ) : null;
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Todays Sales",
      value: billSummary?.total_sales,
      desc: `+${billSummary?.avg_sale_change_percentage}% vs yesterday`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-green-fg)]",
      icon: <RupeesIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Unpaid Bills",
      value: billSummary?.total_transactions_pending,
      desc: `₹${billSummary?.total_sales_pending} pending`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-orange-fg)]",
      icon: <TimerIconBg />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Returns",
      value: billSummary?.return_count,
      desc: `₹${billSummary?.total_refunded} refunded`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-red-fg)]",
      icon: <ReturnIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Avg. Sale",
      value: billSummary?.today_avg_sale,
      desc: `+${billSummary?.today_avg_sale}% vs yesterday`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-blue-fg)]",
      icon: <AvgSaleIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];
  const paymentMethods = [
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)] ",
      label: "Cash",
      value: billSummary?.cash_amount,
      desc: billSummary?.cash_percentage,
      icon: <CashIcon />,
      iconConClass: "bg-[var(--list-payMet-cash-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "Card ",
      value: billSummary?.card_amount,
      desc: billSummary?.card_percentage,
      icon: <CardIcon />,
      iconConClass: "bg-[var(--list-payMet-card-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "UPI ",
      value: billSummary?.upi_amount,
      desc: billSummary?.upi_percentage,
      icon: <UpiICon />,
      iconConClass: "bg-[var(--list-payMet-upi-bg)] ",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "Credit",
      value: billSummary?.credit_amount,
      desc: billSummary?.credit_percentage,
      icon: <TimerIcon />,
      iconConClass: "bg-[var(--list-payMet-credit-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
          // <div
          //   className={`rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between ${sum?.conClass}`}
          // >
          //   <div className="flex flex-col ">
          //     <div className="text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]">
          //       {sum?.label}
          //     </div>
          //     <span className="text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2">
          //       {sum?.value}
          //     </span>
          //     <p className={`${sum?.descClass} mt-2`}>{sum?.desc}</p>
          //   </div>{" "}
          //   <div>{sum?.icon}</div>
          // </div>
        ))}
      </div>
    ) : (
      <></>
    );

  const paymentArray =
    paymentMethods?.length > 0 ? (
      <div className="px-[24px] pt-[16px]">
        <div className="border-radius   h-[5rem] w-[100%] p-3 flex justify-between bg-[var(--trans-stats-con-Sblue-bg)]">
          {paymentMethods?.map((pay) => (
            <div className="flex gap-3 w-fit items-center">
              <div className={`p-2 rounded-[12px] ${pay?.iconConClass}`}>
                {pay?.icon}
              </div>
              <div className="flex flex-col gap-2">
                <span className="text-[length:var(--bill-list-payMet-lab-fs)] font-[var(--bill-list-payMet-lab-fw)] text-[var(--bill-list-payMet-lab-fg)]">
                  {pay?.label}
                </span>
                <div className="flex gap-2 items-center">
                  <span className="text-[length:var(--bill-list-payMet-val-fs)] font-[var(--bill-list-payMet-val-fw)] text-[var(--bill-list-payMet-val-fg)]">
                    ₹{pay?.value}
                  </span>{" "}
                  <span className="text-[length:var(--bill-list-payMet-desc-fs)] font-[var(--bill-list-payMet-desc-fw)] text-[var(--bill-list-payMet-desc-fg)]">
                    ({pay?.desc ?? 0} %)
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <></>
    );

  console.log(heading, "loading");

  const todaysBulkState = getBulkSyncState({
    moduleKey: "billing_todays_bulk",
    lastSynced: billingLastSynced,
  });

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="invoice"
      list={true}
      onclkFn={() => {
        navigate(
          `/add-sales-invoice/${encodeURIComponent(JSON.stringify([]))}/invoice`
        );
      }}
      title="Billings"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            transaction="Invoice"
            transaction_type="Billing"
            setInvoiceItems={setInvoiceItems}
            invoiceItems={invoiceItems}
            options={options}
            orders={orders}
            setOrders={setOrders}
            tableHeading1={tableHeading1}
            is_checkbox_req={true}
            onClickItemFn={(id) => navigate(`/view-bill/${id}`)}
            list={true}
            onclkFn={() => {
              navigate(`/add-bill`);
            }}
            permissionFn={permissionFn}
            module={"invoice"}
            path="bill"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={invoiceDeleteAction}
            label="Billings"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={[
              ...heading,
              ...(!isAdmin
                ? [{ label: "", value: "sync_action", display: false, column: false }]
                : []),
            ]}
            beforeDateSlot={
              <div title={`Last synced: ${todaysBulkState.lastSyncedLabel}`}>
                <AddButton
                  prefixIcon={false}
                  isDisabled={syncTodaysLoading || todaysBulkState.disabled}
                  loading={syncTodaysLoading}
                  className="flex justify-center items-center h-[32px] px-[12px] gap-[8px] border-radius whitespace-nowrap transition duration-300 ease-in-out text-[length:--primary-button-font-size] font-[var(--primary-button-font-weight)] bg-[var(--primary-button-bg-color)] text-[var(--primary-button-fg-color)] hover:bg-[var(--primary-button-hover-color)] cursor-pointer"
                  onclkFn={handleSyncTodaysBills}
                  text={
                    todaysBulkState.disabled
                      ? `Sync Todays Bills (${formatDashboardCountdown(todaysBulkState.remainingMs)})`
                      : "Sync Todays Bills"
                  }
                  spinnerClass="h-4 w-4 border-t-2 border-[var(--primary-button-fg-color)]"
                />
              </div>
            }
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "sot_invoice_number",
              from: "",
              to: "",
              inputValue: "",
              order_status: "",
              payment_status: "",
            }}
            handleSelect={(item) => {
              if (item?.value === "return_bill") {
                navigate(
                  `/add-return-bill/${encodeURIComponent(
                    JSON.stringify(invoiceItems)
                  )}/bill`
                );
              }
            }}
            transactionKey="sot"
            ViewAction={invoiceViewAction}
            summaryArray={summaryArray}
            paymentArray={paymentArray}
            extraFilters={[
              { label: "Item Code", value: "item_code", column: true },
              { label: "Item Name", value: "item_name", column: true },
              { label: "Custom Invoice Number", value: "sot_custom_invoice_number", column: true }
            ]}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default BillingTable;

const tableHeading1 = [
  { label: "PRODUCT NAME", value: "item_name" },
  { label: "GENERIC NAME", value: "item_generic_name" },
  { label: "ITEM CODE", value: "item_code" },
  { label: "UOM", value: "item_uom" },
  { label: "PRICE (₹)", value: "item_unit_price" },
  { label: "QTY", value: "item_quantity" },
  {
    label: "OPEN QTY",
    value: "item_open_quantity",
  },

  { label: "TOTAL (₹)", value: "item_total_amount" },
  // {
  //   label: "sot custom invoice number",
  //   value: " sot_custom_invoice_number",
  // },
];

const options = [{ value: "return_bill", label: "Return Bill" }];
